export enum ApplicationType {
    Public = 0,
    Custom = 1,
}
